import { centerCrop, Crop, makeAspectCrop } from 'react-image-crop';

export const getCroppedImage = (image: HTMLImageElement, crop: Crop) => {
  if (!crop.width || !crop.height) return null;

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const canvas = document.createElement('canvas');
  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;
  const ctx = canvas.getContext('2d')!;

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY,
  );

  return canvas.toDataURL('image/jpeg', 1);
};

export const centerAspectCrop = (width: number, height: number) => {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      width / height,
      width,
      height,
    ),
    width,
    height,
  );
};

export const base64ToFile = (
  base64Data: string,
  fileName: string,
  mimeType = 'image/jpeg',
): File => {
  const arr = base64Data.split(',');
  const byteString = atob(arr[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mimeType });
};
